import React from "react";
import { useTranslation } from "react-i18next";
import PageHeader from "components/common/PageHeader";
import EmbeddedSymantecEDRApp from "./EmbeddedSymantecEDRApp";
const SymantecEDRApp = () => {
  const { t } = useTranslation("enterprise_integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: t("symantecedr.app.title") }, /* @__PURE__ */ React.createElement("span", null, t("symantecedr.app.description"))), /* @__PURE__ */ React.createElement(EmbeddedSymantecEDRApp, null));
};
export default SymantecEDRApp;
